import React from 'react';
import { DivHeader } from './styles';
import { fieldsPropType } from './PropTypes';

function HeaderComponent({ fields }) {
  return (
    <>
      <DivHeader area="1 / datefrom">
        {fields.datefrom.label}
      </DivHeader>
      <DivHeader area="1 / dateto">
        {fields.dateto.label}
      </DivHeader>
      <DivHeader area="1 / ratio">
        {fields.ratio.label}
      </DivHeader>
    </>
  );
}

HeaderComponent.propTypes = {
  fields: fieldsPropType,
};

HeaderComponent.defaultProps = {
  fields: {},
};
export default HeaderComponent;
